import { render } from "./SeparatePagination.vue?vue&type=template&id=87fbac5c&scoped=true&ts=true"
import script from "./SeparatePagination.vue?vue&type=script&lang=ts"
export * from "./SeparatePagination.vue?vue&type=script&lang=ts"

import "./SeparatePagination.vue?vue&type=style&index=0&id=87fbac5c&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87fbac5c"]])

export default __exports__